export default "__VITE_ASSET__985b952d__"